import { Component, OnInit } from '@angular/core';
import { GalleryService } from 'src/services/gallery.service';
import { Title, Meta } from '@angular/platform-browser';
import mixitup from 'mixitup';


@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.scss']
})
export class GaleriaComponent implements OnInit {



  groupedVideos: any[];

  videos = [
    {
      idVideo: "",
         idsVideos: [
          "x1inxFVurQ0",
        "XhJCWa9y-yA",
        "FoNrmfF451c",
        "-wnhykqkHsU",
        "v9qQPzPL26Y",
        "1Z0DjizF5IM",
        "Tzm_h3pit5E",
        "d0t8v3Cy0P4",
        "a-eg1qSV1GU",
        "nRyU1hJNVro",
        "xnSD1kKVJNc",
        "xDcJmncTBZE"
      ],
      title: "Sorteo Aniversario 2025",
      name: "Sorteo Aniversario",
      categoria: "Sorteo Aniversario",
      img: [


        { src: 'assets/images/ganadores/Foto1.png' },
        { src: 'assets/images/ganadores/Foto2.png' },
        { src: 'assets/images/ganadores/Foto3.png' },
        { src: 'assets/images/ganadores/Foto4.png' },
        { src: 'assets/images/ganadores/Foto5.png' },
        { src: 'assets/images/ganadores/Foto6.png' },
        { src: 'assets/images/ganadores/Foto7.png' },
        { src: 'assets/images/ganadores/Foto8.png' },
        { src: 'assets/images/ganadores/Foto9.png' },
        { src: 'assets/images/ganadores/Foto10.png' },

      ]
    },
    {
      idVideo: "FxNkhjL-Qk4",
      title: "La señora Guadalupe es el 1° Lugar de comprador del 2° Sorteo Oportuno 2025",
      name: "Ganadores",
      categoria: "Ganadores",
      img: []
    },
    {
      idVideo: "3-BNREODmhI",
      title: "Fernanda es el 1° lugar de Colaborador del 2° Sorteo Oportuno 2025",
      name: "Ganadores",
      categoria: "Ganadores",
      img: []
    },
    {
      idVideo: "pfNkB8_oqSw",
      title: "Lía la afortunada ganadora del 2º lugar de colaborador en el 2º Sorteo Oportuno.",
      name: "Ganadores",
      categoria: "Ganadores",
      img: []
    },
    {
      idVideo: "gHtkiOgM3aI",
      title: "Lorena ganadora del 3º lugar de comprador en el 2º Sorteo Oportuno.",
      name: "Ganadores",
      categoria: "Ganadores",
      img: []
    },
    {
      idVideo: "rGRjELmesIk",
      title: "José se llevó el 5º lugar de colaborador en el 2º Sorteo Oportuno 2025",
      name: "Ganadores",
      categoria: "Ganadores",
      img: []
    },
    
    {
      idVideo: "hrbrnUvZJR4",
      title: "Sorteo Egresados 2025",
      name: "Sorteo Egresados",
      categoria: "Sorteo Egresados",
      img: [


        { src: 'assets/images/ganadores/so3_10.jpg' },
        { src: 'assets/images/ganadores/so3_11.jpg' },
        { src: 'assets/images/ganadores/so3_12.jpg' },
        { src: 'assets/images/ganadores/so3_13.jpg' },
        { src: 'assets/images/ganadores/so3_14.jpg' },
        { src: 'assets/images/ganadores/so3_15.jpg' },
      ]
    },

    {
      idVideo: "NeAIsbKNsu0",
      title: "3° Sorteo Oportuno 2025",
      name: "Tercer Sorteo Oportuno",
      categoria: "Sorteos Oportunos",
      img: [

        { src: 'assets/images/ganadores/so3_2.jpg' },
        { src: 'assets/images/ganadores/so3_3.jpg' },
        { src: 'assets/images/ganadores/so3_4.jpg' },
        { src: 'assets/images/ganadores/so3_6.jpg' },
        { src: 'assets/images/ganadores/so3_7.jpg' },

        { src: 'assets/images/ganadores/so3_8.jpg' },
        { src: 'assets/images/ganadores/so3_9.jpg' },

      ]
    },
    {
      idVideo: "_aR47qvcvDI",
      title: "2° Sorteo Oportuno 2025",
      name: "Segundo Sorteo Oportuno",
      categoria: "Sorteos Oportunos",
      img: [
        { src: 'assets/images/ganadores/so2_1.jpg' },
        { src: 'assets/images/ganadores/so2_2.jpg' },
        { src: 'assets/images/ganadores/so2_3.jpg' },
        { src: 'assets/images/ganadores/so2_4.jpg' },
        { src: 'assets/images/ganadores/so2_5.jpg' },
        { src: 'assets/images/ganadores/so2_6.jpg' },
        { src: 'assets/images/ganadores/so2_7.jpg' },
      ]
    },
    {
      idVideo: "rzCx968FLq4",
      title: "1° Sorteo Oportuno 2025",
      name: "Primer Sorteo Oportuno",
      categoria: "Sorteos Oportunos",
      img: [
        { src: 'assets/images/ganadores/so1_1.jpg' },
        { src: 'assets/images/ganadores/so1_2.jpg' },
        { src: 'assets/images/ganadores/so1_3.jpg' },
        { src: 'assets/images/ganadores/so1_4.jpg' },
        { src: 'assets/images/ganadores/so1_5.jpg' },
        { src: 'assets/images/ganadores/so1_6.jpg' },
        { src: 'assets/images/ganadores/so1_7.jpg' },
        { src: 'assets/images/ganadores/so1_8.jpg' },
        { src: 'assets/images/ganadores/so1_9.jpg' }
      ]
    },
    // { idVideo: "_aR47qvcvDI", title: "2° Sorteo Oportuno 2025", name: "Primer Sorteo Oportuno", categoria: "Sorteos Oportunos" },
    // { idVideo: "NeAIsbKNsu0", title: "3° Sorteo Oportuno 2025", name: "Primer Sorteo Oportuno", categoria: "Sorteos Oportunos" },
  ];


  constructor(private _galleryService: GalleryService, private titleService: Title, private metaTagService: Meta) {
  }

  ngOnInit(): void {
    this.groupedVideos = this.groupByCategory(this.videos);

  }

  groupByCategory(videos: any[]) {
    const grouped = videos.reduce((acc, video) => {
      const categoria = video.categoria || 'Sin categoría';
      if (!acc[categoria]) {
        acc[categoria] = [];
      }
      acc[categoria].push(video);
      return acc;
    }, {});

    return Object.keys(grouped).map(key => ({
      categoria: key === 'Sin categoría' ? null : key,
      videos: grouped[key]
    }));
  }

  ngAfterViewInit() {
    const mixer = mixitup('.conainter-photos', {
      selectors: {
        target: '.mix' // Elementos a mezclar/filtros
      },
      animation: {
        duration: 300
      }
    });
    mixer.filter('.vg');

  }
}
